import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import 'moment-timezone'

import Panel from 'beam/dist/Panel'
import BeamIcon from 'beam/dist/BeamIcon'
import withStyles from 'beam/dist/styles'

import ExploreContent from './ExploreContent'
import ErrorBoundary from '../ErrorBoundary'

const dataTestIdPrefix = 'App-Recordings-MediaPlayer-Explore-'

const styles = theme => ({
  root: {},
  body: {
    padding: theme.spacing(1),
    overflowY: 'auto',
    '& section:not(:last-child)': {
      paddingBottom: theme.spacing(4),
      marginBottom: theme.spacing(4),
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
})

const ExplorePanel = props => {
  const { classes, t, ...contentProps } = props

  return (
    <Panel
      titleIcon={<BeamIcon>InformationOutline</BeamIcon>}
      title={t('details')}
      dense
      variant="light"
      dataTestId={`${dataTestIdPrefix}panel`}
      headerTestId={`${dataTestIdPrefix}panel-heading`}
      classes={{
        root: classes.root,
        body: classes.body,
      }}
    >
      <ErrorBoundary key={contentProps.loading}>
        <ExploreContent {...contentProps} />
      </ErrorBoundary>
    </Panel>
  )
}

ExplorePanel.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
}

export { ExplorePanel as UnstyledExplorePanel }
export default withTranslation()(withStyles(styles)(ExplorePanel))
